












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TinymceEditor from '@/components/tinymce-editor.vue'

@Component({ components: { TinymceEditor } })
export default class Article extends Vue {
    @Prop()
    private categoryId !: number;
    private myCategories = [];
    private curCategoryId =0;

    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};

    created() {
        //this.$route.meta.goBack = this.categoryId;
        this.reloadCategory();
    }

    reloadCategory() {
        if (this.categoryId)
            this.curCategoryId = this.categoryId;

        this.reload();

        this.$apis.getCategories(1, 1000)
            .then((res: any) => {
                this.myCategories = res.data;
            });
    }

    reload() {
        this.$apis.getArticles(this.curCategoryId, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    onCategory(value: any) {
        this.curCategoryId = value;
        this.pageIndex = 1;
        this.reload();
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delArticles({ data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 详情
    onView(id: string) {
        this.$router.push({ path: "/study/content", query: { articleId: id } });
    }

    // 附件
    onFiles(id: string) {
        this.$router.push({ path: "/training/file", query: { articleId: id } });
    }

    // 新增
    onAdd() {
        this.editForm = {
            categoryId: this.curCategoryId,
            title: "",
            author: "",
            sequence: 0,
            content: ""
        }
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        this.editForm = {
            id: row.id,
            categoryId: this.curCategoryId,
            title: row.title,
            author: row.author,
            sequence: row.sequence,
            content: row.content
        }
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;
        
        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postArticle(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                     +
                        this.$message({
                            type: 'success',
                            message: '提交成功!'
                        });
                });
        } else {
            // 编辑
            this.$apis.putArticle(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }
    }
}
